// Keep API values in one place. Lottery/provider IDs and prize numbers remain strings.
export const ReferenceLottery = Object.freeze({ ThaiGovernment: '1', Lao: '24' })

export const ReferenceSourceStatus = Object.freeze({
  Available: 'available',
  Pending: 'pending',
  WrongDraw: 'wrong-draw',
  Unavailable: 'unavailable',
})

export const ReferenceAction = Object.freeze({ Calculate: 'calculate', Dispatch: 'dispatch' })

export const ReferenceOutcome = Object.freeze({
  Match: 'match',
  Mismatch: 'mismatch',
  Partial: 'partial',
  Unavailable: 'unavailable',
})
